<template>
  <v-container
    class="px-8 pt-6 pb-16 mb-10"
    style="max-width: 500px; margin-right: auto; margin-left: auto"
  >
    <v-row no-gutters class="text-h4 font-weight-bold"
      ><span class="main-font">About</span></v-row
    >
    <v-row no-gutters class="text-h5 font-weight-bold mt-8"
      ><span class="main-font">Why this app?</span></v-row
    >

    <v-row no-gutters class="mt-4"
      >We believe in the benefits of plants on us. The purpose of this app is to
      encourage each other to take care of plants.</v-row
    >

    <v-row no-gutters class="text-h5 font-weight-bold mt-8"
      ><span class="main-font">Roadmap</span></v-row
    >
    <v-row no-gutters class="mt-4"
      >The roadmap is defined according to the feedback from the
      community.</v-row
    >

    <v-row no-gutters class="mt-4"
      ><v-btn class="text-none" rounded large depressed outlined to="/ideas"
        >Community's ideas</v-btn
      ></v-row
    >

    <v-row no-gutters class="text-h5 font-weight-bold mt-8 mb-4"
      ><span class="main-font">Contributors</span></v-row
    >

    <v-row
      class="py-4"
      no-gutters
      justify="center"
      v-for="contributor in contributors"
      :key="contributor.id"
      ><v-col cols="auto" class="pr-4"
        ><v-img
          @click="goToLink(contributor.link)"
          :src="contributor.profilePictureUrl"
          class="white rounded-circle shrink elevation-1"
          width="70"
          height="70"
          transition="fade-transition"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-icon size="20" color="white">mdi-account</v-icon>
            </v-row>
          </template>
        </v-img></v-col
      ><v-col
        @click="
          toggleLove(
            {
              itemId: contributor.id,
              target: 'contributors',
              self,
            },
            contributor
          )
        "
      >
        <v-row
          no-gutters
          class="main-font font-weight-bold"
          style="font-size: 20px"
          ><v-col align-self="center" cols="auto"
            >{{ contributor.nickname }} </v-col
          ><v-col align-self="center"
            ><v-chip
              small
              class="ml-3 px-2 mb-1"
              dark
              color="accent"
              :outlined="!contributor.loversId.includes(self.id)"
              >{{ contributor.numberOfLovers }}
              <v-icon class="ml-2 pr-1">{{
                contributor.loversId.includes(self.id)
                  ? "mdi-heart"
                  : "mdi-heart-outline"
              }}</v-icon>
            </v-chip></v-col
          >
        </v-row>
        <v-row no-gutters class="text-capitalize font-weight-bold">{{
          contributor.role
        }}</v-row>
        <v-row no-gutters class="text-capitalize body-2">{{
          contributor.contributions
        }}</v-row>
        <v-row
          v-if="contributor.timeSpent"
          no-gutters
          class="text-caption primary--text"
          >~{{ contributor.timeSpent }} hours</v-row
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("self", ["self"]),
    ...mapState("contributors", ["contributors", "contributorsPending"]),
  },
  mounted() {
    this.$store.dispatch("contributors/getContributors");
  },
  methods: {
    toggleLove(params, contributor) {
      let newContributor = contributor;
      if (newContributor.loversId.includes(this.self.id)) {
        newContributor.loversId = newContributor.loversId.filter((i) => {
          return i !== this.self.id;
        });
        newContributor.numberOfLovers -= 1;
      } else {
        newContributor.loversId.push(this.self.id);
        newContributor.numberOfLovers += 1;
      }
      this.$store.dispatch("level/updateLevel", {
        field: "contributor",
        value: true,
      });
      this.$store.commit("contributors/updateContributor", newContributor);
      this.$store.dispatch("lovers/toggleLove", params);
    },
    goToLink(link) {
      window.open(link, "_blank");
    },
  },
};
</script>
